// send event information to Google Tag Manager
export default function dataLayerPush(action) {
  const dataLayer = window.dataLayer;

  if (dataLayer) {
    dataLayer.push({
      'event': action, // eslint-disable-line quote-props
    });
  } else {
    console.log('analytics inactive');
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/utils/analytics.js